'use client';

import { PropsWithChildren } from 'react';

import Menu from './Menu';

const Right = ({ children }: PropsWithChildren) => {
	return <div className="min-h-10 flex gap-2 justify-end">{children}</div>;
};

Right.Menu = Menu;

export default Right;
